import React from 'react';
import { usePageContent } from '../../hooks/usePageContent';

const ICON_MAP = {
  phone:    '/images/icons/phone-speaker.svg',
  location: '/images/icons/location-pin-2.svg',
  email:    '/images/icons/envelope.svg',
};

const ContactUsPage = () => {
  const { find } = usePageContent('contact-us');
  const c = find('contactDetails') || {};
  const items = c.items || [];

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'Contact Us'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        <div className="contact-page">
          {items.map((item, i) => (
            <div key={i} className="contact-page__row">
              <div className="contact-page__icon-container">
                <img
                  className="contact-page__icon-container-icon"
                  src={ICON_MAP[item.type]}
                  alt=""
                />
              </div>
              <div className="contact-page__details-container">
                {item.type === 'phone' && (
                  <>
                    <h2 className="contact-page__details-container-text">
                      <strong>
                        {item.heading}{' '}
                        <a className="contact-page__details-container-tel-link" href={item.phoneHref}>
                          {item.phone}
                        </a>
                      </strong>
                    </h2>
                    <p className="contact-page__details-container-text">{item.hours}</p>
                  </>
                )}
                {item.type === 'location' && (
                  <>
                    <h2 className="contact-page__details-container-text">
                      <strong>{item.heading}</strong>
                    </h2>
                    <p className="contact-page__details-container-text">{item.hours}</p>
                    <p className="contact-page__details-container-text">
                      <a className="contact-page__details-container-link" href={item.linkHref} target="_blank" rel="noopener noreferrer">
                        {item.linkText}
                      </a>
                    </p>
                  </>
                )}
                {item.type === 'email' && (
                  <>
                    <h2 className="contact-page__details-container-text">
                      <strong>{item.heading}</strong>
                    </h2>
                    <p className="contact-page__details-container-text">{item.intro}</p>
                    <p className="contact-page__details-container-text">
                      Send an email to{' '}
                      <a className="contact-page__details-container-link" href={item.emailHref}>
                        {item.email}
                      </a>
                      .
                    </p>
                    <p className="contact-page__details-container-text">{item.instructions}</p>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
